import {
  Button,
  Col,
  Icon,
  Layout,
  Row,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import { Constant } from "../../config";
import { GatewayColor, GatewayName } from "../../config/gateway";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import MyModal from "../Modal";
import SendersDefaultForm from "./default-form";
import SearchForm from "./search-form";
import "./style.css";
import { checkRolePermission } from "../../services/permission";
import { permissionName, permissionType } from "../../config/permission";

const { Content } = Layout;

export const SENDERS_DEFAULT_GATEWAY_FLAG_UPDATING_KEY =
  "senders-default-gateway-flagUpdatingData";

class SendersDefaultGateway extends Component {
  state = {
    loading: false,

    countryList: [],
    currentCountryAbbr: "ALL",
    currentGatewayID: -1,
    currentPage: 1,
    currentSearch: "",
    dataSource: [],
    gatewayList: [],
    isReload: false,
    totalRows: 0,
    sendersPoolList: [],

    current_data: {
      id: 0,
      senders_pool_id: undefined,
    },
    flagCreateOrUpdateForm: true, // true: created, false: updated
    visibleFormModal: false,
    canAddSenderGeneric: false,
    canReloadSenderGeneric: false,
    canEditSenderGeneric: false,
    canDeleteSenderGeneric: false,
    canSetDefaultSenderGeneric: false,
  };

  columns = [
    {
      align: "center",
      dataIndex: "created_date",
      render: (created_date) => {
        if (!created_date) return "-";

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {created_date}
          </Moment>
        );
      },
      title: "วัน / เวลา สร้าง",
      width: "150px",
    },
    {
      align: "center",
      dataIndex: "gateway_id",
      render: (_, record) => {
        return this.getGatewayTag(
          record.gateway_detail ? record.gateway_detail.key_name || "" : ""
        );
      },
      title: "Gateway",
      width: "200px",
    },
    {
      align: "center",
      dataIndex: "country_abbr",
      render: (country_abbr) => {
        return this.getCountryAbbrTag(country_abbr || "");
      },
      title: "ประเทศ",
      width: "100px",
    },
    {
      align: "center",
      dataIndex: "sender",
      title: "Sender",
      width: "200px",
    },
    {
      align: "center",
      dataIndex: "is_default",
      render: (isDefault, record) => {
        if (typeof isDefault !== "boolean" || !isDefault) return "-";

        return <Tag color="blue">Default</Tag>;
      },
      title: "Default",
      width: "100px",
    },
    {
      align: "center",
      dataIndex: "updated_date",
      render: (updated_date) => {
        if (!updated_date) return "-";

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {updated_date}
          </Moment>
        );
      },
      title: "วัน / เวลา แก้ไข ล่าสุด",
      width: "150px",
    },
    {
      title: "ดำเนินการ",
      align: "center",
      dataIndex: "id",
      render: (id, record) => {
        if (typeof id === "undefined") return "-";

        const countryAbbr = record.country_abbr || "";
        const isDefault =
          typeof record.is_default === "boolean"
            ? record.is_default || false
            : false;
        const gatewayKenName = record.gateway_detail
          ? record.gateway_detail.key_name || ""
          : "";
        const sender = record.sender || "";

        if (
          !this.state.canEditSenderGeneric &&
          !this.state.canDeleteSenderGeneric &&
          !this.state.canSetDefaultSenderGeneric
        ) {
          return <Icon type="lock" />;
        }

        return (
          <div>
            {!isDefault && this.state.canSetDefaultSenderGeneric && (
              <Tooltip placement="top" title="Set Default">
                <Button
                  type="primary"
                  icon="environment"
                  onClick={() =>
                    this.setIsDefault(id, sender, gatewayKenName, countryAbbr)
                  }
                  style={{ marginRight: "5px" }}
                />
              </Tooltip>
            )}
            {this.state.canEditSenderGeneric && (
              <Tooltip placement="top" title="แก้ไข">
                <Button
                  icon="edit"
                  onClick={() => this.edit(record || undefined)}
                  style={{ marginRight: "5px" }}
                />
              </Tooltip>
            )}

            {this.state.canDeleteSenderGeneric && (
              <Tooltip placement="top" title="ลบ">
                <Button
                  type="danger"
                  icon="delete"
                  onClick={() =>
                    this.delete(id, sender, gatewayKenName, countryAbbr)
                  }
                />
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];
  limit = 20;

  componentWillMount() {
    this.props.fetchMenuAction("senders", "senders-default-gateway");
    this.setState({ loading: true });

    const canAddSenderGeneric = checkRolePermission(
      permissionName.SENDER_GENERIC,
      permissionType.CREATE
    );
    const canReloadSenderGeneric = checkRolePermission(
      permissionName.SENDER_GENERIC,
      permissionType.RELOAD
    );
    const canEditSenderGeneric = checkRolePermission(
      permissionName.SENDER_GENERIC,
      permissionType.UPDATE
    );
    const canDeleteSenderGeneric = checkRolePermission(
      permissionName.SENDER_GENERIC,
      permissionType.DELETE
    );
    const canSetDefaultSenderGeneric = checkRolePermission(
      permissionName.SENDER_GENERIC,
      permissionType.SET_DEFAULT
    );

    this.setState({
      canAddSenderGeneric,
      canReloadSenderGeneric,
      canEditSenderGeneric,
      canDeleteSenderGeneric,
      canSetDefaultSenderGeneric,
    });
  }

  async componentDidMount() {
    let isReload = this.state.isReload;
    const tmp = window.localStorage.getItem(
      SENDERS_DEFAULT_GATEWAY_FLAG_UPDATING_KEY
    );
    if (+tmp === 1) isReload = true;

    await this.getDataList();
    this.setState({
      countryList: await this.getCountryList(),
      gatewayList: await this.getGatewayList(),
      isReload,
      loading: false,
      sendersPoolList: await this.getSendersPoolList(),
    });
  }

  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.getDataList(
      page,
      this.state.currentSearch,
      this.state.currentCountryAbbr,
      this.state.currentGatewayID
    );

    this.setState({ loading: false });
  };

  create = async () => {
    this.setState({
      loading: true,
      sendersPoolList: await this.getSendersPoolList(),
    });

    this.setState({
      current_data: {
        id: 0,
        senders_pool_id: undefined,
      },
      loading: false,
      flagCreateOrUpdateForm: true,
      visibleFormModal: true,
    });
  };

  delete = (id = 0, sender = "", gatewayKeyName, countryAbbr) => {
    if (!id) return 0;

    MyModal.confirm(
      "ต้องการลบรายการนี้ ใช่หรือไม่ ?",
      <span>
        {this.getGatewayTag(gatewayKeyName)}
        {this.getCountryAbbrTag(countryAbbr)}
        {sender || "-"}
      </span>,
      async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({ loading: true });

        let isReload = this.state.isReload;

        try {
          await axios({
            url: `${Constant.SENDERS_API}/${id}`,
            method: "DELETE",
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem(Constant.SessionKey),
            },
          });

          window.localStorage.setItem(
            SENDERS_DEFAULT_GATEWAY_FLAG_UPDATING_KEY,
            "1"
          );
          isReload = true;

          MyModal.success("ลบรายการสำเร็จ");
        } catch (e) {
          console.log(e);
          MyModal.error(
            "เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง"
          );
        }

        await this.changePage(this.state.currentPage);
        this.setState({
          isReload,
          loading: false,
        });
      },
      "ยืนยัน",
      "ยกเลิก"
    );
  };

  edit = async (d) => {
    if (!d) return 0;
    if (!d.id || !d.sender) return 0;

    this.setState({
      loading: true,
      sendersPoolList: await this.getSendersPoolList(
        d.senders_pool_id || undefined
      ),
    });

    this.setState({
      current_data: {
        id: d.id,
        senders_pool_id: d.senders_pool_id,
      },
      flagCreateOrUpdateForm: false,
      loading: false,
      visibleFormModal: true,
    });
  };

  formHandleSubmit = () => {
    const { form } = this.formRef.props;

    form.validateFields(async (err, values) => {
      if (err) return;

      MyModal.confirm(
        "ยืนยันบันทึกข้อมูล ใช่หรือไม่ ?",
        "",
        async (isConfirm) => {
          if (!isConfirm) return;

          this.setState({ loading: true });

          const modeText = this.state.flagCreateOrUpdateForm
            ? "เพิ่ม"
            : "แก้ไข";
          const errorMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeText}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
          const token = localStorage.getItem(Constant.SessionKey);
          let method = "PATCH";
          let url = Constant.SENDERS_API_EDIT_DEFAULT.replace(
            "[id]",
            values.id
          );

          if (this.state.flagCreateOrUpdateForm) {
            method = "POST";
            url = Constant.SENDERS_API_DEFAULT;
          }

          const opt = {
            data: values,
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            method,
            url,
          };

          try {
            await axios(opt);

            if (this.state.flagCreateOrUpdateForm) form.resetFields();

            MyModal.success(`${modeText}ข้อมูลสำเร็จ`, "", async () => {
              await this.changePage(this.state.currentPage);

              window.localStorage.setItem(
                SENDERS_DEFAULT_GATEWAY_FLAG_UPDATING_KEY,
                "1"
              );

              this.setState({
                current_data: {
                  id: 0,
                  senders_pool_id: 0,
                },
                flagCreateOrUpdateForm: true,
                isReload: true,
                loading: false,
                sendersPoolList: await this.getSendersPoolList(),
                visibleFormModal: false,
              });
            });
          } catch (e) {
            let eMsgDetail = "";

            if (e.response && e.response.data && e.response.data.error) {
              const tmp = e.response.data.error;
              eMsgDetail = `[${tmp.code || ""}] ${tmp.name || ""}`;
            }

            MyModal.error(errorMsg, eMsgDetail, () => window.location.reload());
          }
        },
        "ยืนยัน",
        "ยกเลิก"
      );
    });
  };

  formHandleCancel = () => {
    this.setState({
      current_data: {
        id: 0,
        senders_pool_id: undefined,
      },
      visibleFormModal: false,
    });
  };

  getCountryAbbrTag = (country = "") => (
    <Tag color="brown" style={{ fontWeight: "bold" }}>
      {country || "-"}
    </Tag>
  );

  getCountryList = async () => {
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    let rtn = [{ region_code: "ALL", name: "ทั้งหมด" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  };

  getDataList = async (
    page = 1,
    search = "",
    country_abbr = "ALL",
    gateway_id = -1
  ) => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.SENDERS_API_DEFAULT}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: "GET",
      params: {
        page,
        limit: this.limit,
        gateway_id,
        country_abbr,
        search,
        status: "enabled",
      },
      url,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined.");
    } catch (e) {
      console.error(e);
      return;
    }

    this.setState({
      currentPage: resp.data.page || 1,
      dataSource: resp.data.data || [],
      loading: false,
      totalRows: resp.data.total_rows || 0,
    });
  };

  getGatewayList = async () => {
    const opt = {
      url: `${Constant.GATEWAY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    let rtn = [{ id: -1, name: "ทั้งหมด" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  };

  getGatewayTag = (gateway = "") => (
    <Tag color={GatewayColor(gateway)}>{GatewayName(gateway)}</Tag>
  );

  getSendersPoolList = async (sendersPoolID) => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.SENDERS_POOL_API}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: "GET",
      params: {
        filter_out_used: -1,
        id: sendersPoolID,
        sendersPoolID,
        page: 1,
        limit: 1000,
        status: "enabled",
      },
      url,
    };

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  };

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      const currentCountryAbbr = values.country_abbr || "ALL";
      const currentGatewayID = values.gateway_id || -1;
      const currentPage = 1;
      const currentSearch = values.searchTxt || "";

      this.setState({
        currentCountryAbbr,
        currentGatewayID,
        currentPage,
        currentSearch,
        loading: true,
      });

      await this.getDataList(
        currentPage,
        currentSearch,
        currentCountryAbbr,
        currentGatewayID
      );

      this.setState({ loading: false });
    });
  };

  reload = async () => {
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.SENDERS_API}/default-gateway/cache`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: "DELETE",
      url,
    };

    MyModal.confirm(
      `คุณต้องการ Reload ข้อมูล ใช่หรือไม่ ?`,
      "",
      async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({ loading: true });

        try {
          await axios(opt);
        } catch (e) {
          console.error(e);
          MyModal.error(
            "เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง"
          );
          this.setState({ loading: false });
          return;
        }

        MyModal.success(`Reload ข้อมูล สำเร็จ`);

        await this.getDataList();

        window.localStorage.removeItem(
          SENDERS_DEFAULT_GATEWAY_FLAG_UPDATING_KEY
        );

        this.setState({
          isReload: false,
          loading: false,
        });
      },
      "ยืนยัน",
      "ยกเลิก"
    );
  };

  resetSearch = async () => {
    this.setState({ loading: true });

    await this.getDataList(1);

    this.setState({
      currentCountryAbbr: undefined,
      currentGatewayID: undefined,
      currentPage: 1,
      currentSearch: undefined,
      loading: false,
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  setIsDefault = (id = 0, sender = "", gatewayKeyName, countryAbbr) => {
    if (id < 1) {
      window.location.reload();
      return;
    }

    const url = Constant.SENDERS_API_SET_DEFAULT.replace("[id]", id);

    MyModal.confirm(
      `ต้องการ Set Default รายการนี้ ใช่หรือไม่ ?`,
      <span>
        {this.getGatewayTag(gatewayKeyName)}
        {this.getCountryAbbrTag(countryAbbr)}
        {sender || "-"}
      </span>,
      async (isConfirm) => {
        if (!isConfirm) {
          return;
        }

        this.setState({ loading: true });

        try {
          await axios({
            url,
            method: "PATCH",
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem(Constant.SessionKey),
            },
          });

          MyModal.success(`Set Default สำเร็จ`);
        } catch (e) {
          console.log(e);
          MyModal.error(
            "เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง"
          );
        }

        await this.changePage(this.state.currentPage);
        this.setState({ loading: false });
      },
      "ยืนยัน",
      "ยกเลิก"
    );
  };

  toggleStatus = (f, id = 0, sender = "", gatewayKeyName, countryAbbr) => {
    if (id < 1) {
      window.location.reload();
      return;
    }

    let textConfirm = "ปิดการใช้งาน";
    let url = Constant.SENDERS_API_DISABLED;
    if (f) {
      textConfirm = "เปิดการใช้งาน";
      url = Constant.SENDERS_API_ENABLED;
    }

    MyModal.confirm(
      `ต้องการ ${textConfirm} รายการนี้ ใช่หรือไม่ ?`,
      <span>
        {this.getGatewayTag(gatewayKeyName)}
        {this.getCountryAbbrTag(countryAbbr)}
        {sender || "-"}
      </span>,
      async (isConfirm) => {
        if (!isConfirm) {
          return;
        }

        this.setState({ loading: true });

        let isReload = this.state.isReload;

        try {
          await axios({
            url: url.replace("[id]", id),
            method: "PATCH",
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem(Constant.SessionKey),
            },
          });

          window.localStorage.setItem(
            SENDERS_DEFAULT_GATEWAY_FLAG_UPDATING_KEY,
            "1"
          );
          isReload = true;

          MyModal.success(`${textConfirm} สำเร็จ`);
        } catch (e) {
          console.log(e);
          MyModal.error(
            "เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง"
          );
        }

        await this.changePage(this.state.currentPage);
        this.setState({ isReload, loading: false });
      },
      "ยืนยัน",
      "ยกเลิก"
    );
  };

  render() {
    const propsTable = {
      bordered: true,
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: "small",
      },
      size: "small",
      scroll: {
        x: 1200,
      },
    };
    const propsTableForMobile = Object.assign({}, propsTable);

    propsTableForMobile.className = "my-table-mobile";
    propsTableForMobile.columns = this.columns;

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: "16px 0",
              minHeight: 300,
            }}
          >
            <h2>Generic Sender</h2>
            <p className="header-desc">
              Generic Sender ของแต่ละ Gateway และแต่ละประเทศ
            </p>
            <Row className="utility-bar">
              <Col span={6}>
                {this.state.canAddSenderGeneric && (
                  <Button
                    className="add-btn"
                    icon="plus-circle"
                    onClick={() => this.create()}
                  >
                    เพิ่ม
                  </Button>
                )}
                {this.state.canReloadSenderGeneric && (
                  <div>
                    <Button
                      type="primary"
                      onClick={() => this.reload()}
                      disabled={!this.state.isReload}
                    >
                      <Icon type="reload" />
                      Reload
                    </Button>
                    {this.state.isReload ? (
                      <p className="note-danger">
                        * กรุณากดปุ่ม Reload เพื่ออัพเดตข้อมูลใหม่
                      </p>
                    ) : null}
                  </div>
                )}
              </Col>
              <Col span={18}>
                <SearchForm
                  countryList={this.state.countryList}
                  gatewayList={this.state.gatewayList}
                  fn={this.mySearch}
                  fnReset={this.resetSearch}
                />
              </Col>
            </Row>
            <Row className="utility-bar-mobile">
              <Button icon="plus-circle" onClick={() => this.create()}>
                เพิ่ม
              </Button>
            </Row>
            <Row className="utility-bar-mobile">
              <SearchForm
                countryList={this.state.countryList}
                gatewayList={this.state.gatewayList}
                fn={this.mySearch}
                fnReset={this.resetSearch}
              />
            </Row>
            <Table {...propsTable} />
            <Table {...propsTableForMobile} />
          </Content>
        </Spin>
        <SendersDefaultForm
          loading={this.state.loading}
          data={this.state.current_data}
          flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
          onCancel={this.formHandleCancel}
          onCreate={this.formHandleSubmit}
          sendersPoolList={this.state.sendersPoolList}
          visible={this.state.visibleFormModal}
          wrappedComponentRef={this.saveFormRef}
          getGatewayTag={this.getGatewayTag}
          getCountryAbbrTag={this.getCountryAbbrTag}
        />
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(SendersDefaultGateway);



// WEBPACK FOOTER //
// ./src/containers/Senders/default-gateway.js